const DashboardIcon = () => {
    return (<>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11 19.9V4.1C11 2.6 10.36 2 8.77 2H4.73C3.14 2 2.5 2.6 2.5 4.1V19.9C2.5 21.4 3.14 22 4.73 22H8.77C10.36 22 11 21.4 11 19.9Z"
                    fill="#C5C9CE"/>
                <path
                    d="M21.5 19.64V15.36C21.5 14.06 20.5 13 19.27 13H15.23C14 13 13 14.06 13 15.36V19.64C13 20.94 14 22 15.23 22H19.27C20.5 22 21.5 20.94 21.5 19.64Z"
                    fill="#C5C9CE"/>
                <path
                    d="M21.5 8.64V4.36C21.5 3.06 20.5 2 19.27 2H15.23C14 2 13 3.06 13 4.36V8.64C13 9.94 14 11 15.23 11H19.27C20.5 11 21.5 9.94 21.5 8.64Z"
                    fill="#C5C9CE"/>
            </svg>
        </>);
};

const IndexIcon = () => {
    return (<>
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13 0H5C1.5 0 0 2 0 5V15C0 18 1.5 20 5 20H13C16.5 20 18 18 18 15V5C18 2 16.5 0 13 0ZM5 10.25H9C9.41 10.25 9.75 10.59 9.75 11C9.75 11.41 9.41 11.75 9 11.75H5C4.59 11.75 4.25 11.41 4.25 11C4.25 10.59 4.59 10.25 5 10.25ZM13 15.75H5C4.59 15.75 4.25 15.41 4.25 15C4.25 14.59 4.59 14.25 5 14.25H13C13.41 14.25 13.75 14.59 13.75 15C13.75 15.41 13.41 15.75 13 15.75ZM15.5 7.25H13.5C11.98 7.25 10.75 6.02 10.75 4.5V2.5C10.75 2.09 11.09 1.75 11.5 1.75C11.91 1.75 12.25 2.09 12.25 2.5V4.5C12.25 5.19 12.81 5.75 13.5 5.75H15.5C15.91 5.75 16.25 6.09 16.25 6.5C16.25 6.91 15.91 7.25 15.5 7.25Z"
                    fill="#C5C9CE"/>
            </svg>

        </>)
};

const OprationIcon = () => {
    return (<>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.0169 7.99175C21.4148 8.55833 20.9405 9.25 20.2482 9.25H3C2.44772 9.25 2 8.80228 2 8.25V6.42C2 3.98 3.98 2 6.42 2H8.74C10.37 2 10.88 2.53 11.53 3.4L12.93 5.26C13.24 5.67 13.28 5.72 13.86 5.72H16.65C18.4546 5.72 20.0516 6.61709 21.0169 7.99175Z"
                    fill="#C5C9CE"/>
                <path
                    d="M20.9834 10.75C21.5343 10.75 21.9815 11.1957 21.9834 11.7466L22 16.6503C22 19.6003 19.6 22.0003 16.65 22.0003H7.35C4.4 22.0003 2 19.6003 2 16.6503V11.7503C2 11.198 2.44771 10.7503 2.99999 10.7503L20.9834 10.75Z"
                    fill="#C5C9CE"/>
            </svg>


        </>)
};

const ReportIcon = () => {
    return (<>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.19 0H5.81C2.17 0 0 2.17 0 5.81V14.18C0 17.83 2.17 20 5.81 20H14.18C17.82 20 19.99 17.83 19.99 14.19V5.81C20 2.17 17.83 0 14.19 0ZM7.11 14.9C7.11 15.18 6.89 15.4 6.61 15.4H3.82C3.54 15.4 3.32 15.18 3.32 14.9V10.28C3.32 9.65 3.83 9.14 4.46 9.14H6.61C6.89 9.14 7.11 9.36 7.11 9.64V14.9ZM11.89 14.9C11.89 15.18 11.67 15.4 11.39 15.4H8.6C8.32 15.4 8.1 15.18 8.1 14.9V5.74C8.1 5.11 8.61 4.6 9.24 4.6H10.76C11.39 4.6 11.9 5.11 11.9 5.74V14.9H11.89ZM16.68 14.9C16.68 15.18 16.46 15.4 16.18 15.4H13.39C13.11 15.4 12.89 15.18 12.89 14.9V11.35C12.89 11.07 13.11 10.85 13.39 10.85H15.54C16.17 10.85 16.68 11.36 16.68 11.99V14.9Z"
                    fill="#C5C9CE"/>
            </svg>
        </>)
};

const SettingIcon = () => {
    return (<>
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.1 7.2214C16.29 7.2214 15.55 5.9414 16.45 4.3714C16.97 3.4614 16.66 2.3014 15.75 1.7814L14.02 0.791401C13.23 0.321401 12.21 0.601401 11.74 1.3914L11.63 1.5814C10.73 3.1514 9.25 3.1514 8.34 1.5814L8.23 1.3914C7.78 0.601401 6.76 0.321401 5.97 0.791401L4.24 1.7814C3.33 2.3014 3.02 3.4714 3.54 4.3814C4.45 5.9414 3.71 7.2214 1.9 7.2214C0.86 7.2214 0 8.0714 0 9.1214V10.8814C0 11.9214 0.85 12.7814 1.9 12.7814C3.71 12.7814 4.45 14.0614 3.54 15.6314C3.02 16.5414 3.33 17.7014 4.24 18.2214L5.97 19.2114C6.76 19.6814 7.78 19.4014 8.25 18.6114L8.36 18.4214C9.26 16.8514 10.74 16.8514 11.65 18.4214L11.76 18.6114C12.23 19.4014 13.25 19.6814 14.04 19.2114L15.77 18.2214C16.68 17.7014 16.99 16.5314 16.47 15.6314C15.56 14.0614 16.3 12.7814 18.11 12.7814C19.15 12.7814 20.01 11.9314 20.01 10.8814V9.1214C20 8.0814 19.15 7.2214 18.1 7.2214ZM10 13.2514C8.21 13.2514 6.75 11.7914 6.75 10.0014C6.75 8.2114 8.21 6.7514 10 6.7514C11.79 6.7514 13.25 8.2114 13.25 10.0014C13.25 11.7914 11.79 13.2514 10 13.2514Z"
                    fill="#C5C9CE"/>
            </svg>

        </>)
};

export {DashboardIcon,IndexIcon, OprationIcon, ReportIcon, SettingIcon};